import React, { Component } from 'react';
import PropTypes from 'prop-types';
import DataTable from '../../../../components/DataTable/index';
import $ from 'jquery';
import { Filings } from '../../services/Filings';
import { ELECTRONIC_FILING_STATUS } from '../../../../services/constant/constant';

const dateFormatter = new Intl.DateTimeFormat('en-US');
const dateTimeFormatter = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'numeric',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit'
});

class ElectronicFilingsListGrid extends Component {
    render() {
        let { id, dataList } = this.props;
        return (
            <DataTable
                id={id}
                columns={[
                    {
                        title: 'State',
                        data: 'stateCode',
                        className: 'pr-sm'
                    },
                    {
                        title: 'Document<br/>Id',
                        data: 'documentId',
                        className: 'pr-sm'
                    },
                    {
                        title: 'Trust<br/>Name',
                        data: 'trustName'
                    },
                    {
                        title: 'Portfolio<br/>Name',
                        data: 'portfolioName'
                    },
                    {
                        title: 'Class<br/>Name',
                        data: 'className'
                    },
                    {
                        title: 'Date',
                        data: 'sentToStateDate',
                        className: 'pr-sm'
                    },
                    {
                        title: 'Filing<br/>Status',
                        data: 'filingStatus',
                        className: 'pr-sm'
                    },
                    {
                        title: 'Electronic<br/>Status',
                        data: 'electronicFilingStatus',
                        className: 'pr-sm'
                    },
                    {
                        title: 'Confirmation<br/>Id',
                        data: 'confirmationId'
                    },
                    {
                        title: 'Notes',
                        data: 'notes'
                    }
                ]}
                data={dataList}
                pageable
                searchable
                sortable
                columnFormat={[
                    {
                        //Date - the sent-to-state date normally; for a failed
                        //e-filing (which has no sent date) show the history
                        //record's ChangeDateTime instead.
                        targets: [5],
                        render: function(data, type, full) {
                            let value =
                                full.electronicFilingStatus ===
                                ELECTRONIC_FILING_STATUS.FAILED
                                    ? full.changeDateTime
                                    : data;
                            if (value) {
                                if (type === 'sort') {
                                    return value;
                                }
                                return dateTimeFormatter.format(new Date(value));
                            }
                            return '';
                        }
                    },
                    {
                        //Filing Status
                        targets: [6],
                        render: function(data) {
                            return Filings.getFilingStatusName(data);
                        }
                    },
                    {
                        //Electronic Status
                        targets: [7],
                        render: function(data) {
                            return Filings.getElectronicFilingStatusName(data);
                        }
                    },
                    {
                        //Trust / Portfolio - limit to 35 characters
                        targets: [2, 3],
                        createdCell: function(td, cellData) {
                            $(td).css('max-width', '155px');
                            td.title = cellData;
                        },
                        render: function(data, type) {
                            if (type === 'display' && data && data.length > 35) {
                                return data.substring(0, 35) + '...';
                            }
                            return data;
                        }
                    },
                    {
                        //Notes - for a failed e-filing, show the state's response
                        //body (the failure reason) instead of the filing notes.
                        targets: [9],
                        createdCell: function(td, cellData, rowData) {
                            if (
                                rowData.electronicFilingStatus ===
                                ELECTRONIC_FILING_STATUS.FAILED
                            ) {
                                td.title = rowData.responseBody || '';
                            }
                        },
                        render: function(data, type, full) {
                            let text =
                                full.electronicFilingStatus ===
                                ELECTRONIC_FILING_STATUS.FAILED
                                    ? full.responseBody || ''
                                    : data || '';
                            if (type === 'display' && text && text.length > 60) {
                                return text.substring(0, 60) + '...';
                            }
                            return text;
                        }
                    }
                ]}
            />
        );
    }
}

ElectronicFilingsListGrid.propTypes = {
    id: PropTypes.string,
    dataList: PropTypes.array.isRequired
};

export default ElectronicFilingsListGrid;



// WEBPACK FOOTER //
// ./src/screens/EmployeePanel/screens/ElectronicFilings/ElectronicFilingsListGrid.js